<template>
    <div class="modal fade credentials-dialog" aria-hidden="true" id="credentials-dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">
                        <template v-if="id_account">Edit Credentials</template>
                        <template v-else>Add Credentials</template>
                    </h3>
                </div>
                <div class="modal-body">
                    <div v-if="submitting">
                        <span class="saving">Saving and rebuilding permissions...</span>
                        <div class="progress">
                            <div class="progress-bar" :class="{ 'progress-bar-striped': progress > 100, 'progress-bar-animated': progress > 100 }" role="progressbar" :style="'width: ' + progress + '%'"></div>
                        </div>
                    </div>
                    <form action="." method="post" class="form" v-else>
                        <div class="form-group row" v-if="id_account">
                            <label class="col-sm-3 col-form-label" for="login-name">id_account</label>
                            <div class="col-sm-9">
                                <input class="form-control" type="text" id="login-name" :value="id_account" disabled/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label" for="login-name">Login name</label>
                            <div class="col-sm-9">
                                <input class="form-control" type="text" id="login-name" v-model="loginname"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label" for="password">Password</label>
                            <div class="col-sm-9">
                                <input class="form-control" type="text" id="password" v-model="password"/>
                            </div>
                        </div>
                        <div class="form-group row" v-if="!id_account">
                            <label class="col-sm-3 col-form-label" for="sites"><abbr title="Comma-separated list of id_sites">Site(s)</abbr></label>
                            <div class="col-sm-9">
                                <input class="form-control" type="text" id="sites" v-model="site"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label" for="company"><abbr title="id_customer of a company">Company</abbr></label>
                            <div class="col-sm-9">
                                <input class="form-control" type="text" id="company" v-model="company"/>
                            </div>
                        </div>

                        <div class="row col-md-auto">
                            <div class="col-auto form-group custom-control custom-radio">
                                <input type="radio" value="0" class="custom-control-input" id="invalid" v-model="status">
                                <label for="invalid" class="custom-control-label">Invalid</label>
                            </div>
                            <div class="col-auto form-group custom-control custom-radio">
                                <input type="radio" value="1" class="custom-control-input" id="access" v-model="status">
                                <label for="access" class="custom-control-label">Access only</label>
                            </div>
                            <div class="col-auto form-group custom-control custom-radio">
                                <input type="radio" value="2" class="custom-control-input" id="in_use" v-model="status">
                                <label for="in_use" class="custom-control-label">In use</label>
                            </div>

                        </div>


                    </form>
                </div>
                <div class="modal-footer">
                    <button :disabled="submitting" ref="modalClose" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button :disabled="submitting" type="button" class="btn btn-primary" @click="saveCredentials">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/data/RepositoryFactory.js'
const PCMRepository = RepositoryFactory.get('pcm')

import { Events } from '@/events.js'

const isSuccessful = function(response) {
    return (response.status >= 200 && response.status <= 299) && response.headers['content-type'].indexOf('application/json') > -1
}

export default {
    name: 'CredentialsDialog',
    data() {
        return {
            submitting: false,
            submitStart: null,
            progress: 0,
            progressInterval: null,
            expectedTime: 2
        }
    },
    props: ['id_account', 'loginname', 'password', 'site', 'company', 'status'],
    methods: {
        saveCredentials() {
            if (!this.loginname && !this.password) {
                Events.$emit('addNotification', {
                    'type': 'error',
                    'msg': 'Login name and password cannot both be empty.',
                    'timeout': 3
                })
                return
            }

            if (this.company) {
                if (this.company % 1 !== 0) {
                    Events.$emit('addNotification', {
                        'type': 'error',
                        'msg': 'Company must be a valid id_customer',
                        'timeout': 3
                    })
                }
            }

            if (this.site) {
                let sites = String(this.site).split(',')
                for (let i = 0; i < sites.length; i++) {
                    if (sites[i] % 1 !== 0) {
                        Events.$emit('addNotification', {
                            'type': 'error',
                            'msg': 'Site(s) must be a comma-separated field of id_sites',
                            'timeout': 3
                        })
                        return
                    }
                }
            }

            let active = this.status || 0

            if (!this.id_account) {
                let type = 'error'
                let msg = 'An error has occurred, please try again later.'
                let timeout = 3

                this.submitting = true

                PCMRepository.addCredentials(localStorage.getItem('token'), this.loginname, this.password, this.site, this.company, active)
                .then((response) => {
                    if (isSuccessful(response)) {
                        type = 'success'
                        msg = 'Success'
                        timeout = 5

                        if ('type' in response.data) { type = response.data['type'] }
                        if ('msg' in response.data) { msg = response.data['msg'] }

                        this.$refs.modalClose.click();
                    }
                })
                .catch((err) => {
                    if (err.response.headers['content-type'] == 'application/json' && 'data' in err.response) {
                        if ('msg' in err.response.data) { msg = err.response.data['msg'] }
                        if ('type' in err.response.data) { type = err.response.data['type'] }
                    }
                })
                .then(() => {
                    this.submitting = false
                    Events.$emit('addNotification', {
                        'type': type,
                        'msg': msg,
                        'timeout': timeout
                    })
                })
            } else {
                let type = 'error'
                let msg = 'An error has occurred, please try again later.'
                let timeout = 3

                this.submitting = true

                PCMRepository.editCredentials(localStorage.getItem('token'), this.id_account, {
                    'loginname': this.loginname,
                    'password': this.password,
                    'company': this.company,
                    'active': active
                })
                .then((response) => {
                    if (isSuccessful(response)) {
                        type = 'success'
                        msg = 'Success'
                        timeout = 5

                        if ('type' in response.data) { type = response.data['type'] }
                        if ('msg' in response.data) { msg = response.data['msg'] }

                        this.$refs.modalClose.click();
                    }
                })
                .catch((err) => {
                    console.log("Error occurred while saving credentials")
                    console.error('Full error:', err)
                    
                    if (err.response && err.response.headers['content-type'] && err.response.headers['content-type'].includes('application/json')) {
                        if (err.response.data) {
                            if (err.response.data.msg) { msg = err.response.data.msg }
                            if (err.response.data.type) { type = err.response.data.type }
                        }
                    } else {
                        msg = 'Unexpected error: ' + (err.message || 'Unknown error')
                    }
                })
                .then(() => {
                    this.submitting = false
                    Events.$emit('addNotification', {
                        'type': type,
                        'msg': msg,
                        'timeout': timeout
                    })
                })
            }
        }
    },
    watch: {
        submitting: function(val) {
            if (val) {
                this.submitStart = (new Date()).getTime()/1000

                this.progressInterval = setInterval(() => {

                    let now = (new Date()).getTime()/1000
                    let timeDiff = (now - this.submitStart)

                    this.progress = timeDiff / this.expectedTime * 100
                }, 50)
            } else {
                clearInterval(this.progressInterval)
                this.progressInterval = null
                this.progress = 0
                this.submitStart = null
            }
        }
    }
}
</script>

<style lang="sass">
@import '@/styles/default.sass'

.saving
    text-align: center
    display: block
    margin: 0 auto 5px

</style>
